import type { IDebtSolutionsStore } from './debtsolutions.model';

//
export const getDefaultState = (): IDebtSolutionsStore => ({
  step: -1, // -1 not started, 1 started
  debts: [],
  planWOStacking: {},
  planWStacking: {},
  addADebtOpen: false,
  scenario: {},
  personInfo: null,
});

const state = getDefaultState();

export default state;
